<template>
    <modal-dialog
        ref="modalDialog"
        :confirmBtnTxt="`Print`"
        :isLoading="isLoading"
        @confirm-dialog="printPDF"
    >
        <template v-slot:title>
            {{ title }}
        </template>
        <template v-slot:body>
            <b-form-group
                label-for="includeDeclined"
                label="Declined Items:"
                label-cols="4"
            >
                <b-form-checkbox
                    id="includeDeclined"
                    v-model="includeDeclined"
                    name="includeDeclined"
                    plain
                    class="col-form-label"
                >
                    <span class="fw-normal">{{ includedDeclinedText }}</span>
                </b-form-checkbox>
            </b-form-group>
        </template>
    </modal-dialog>
</template>

<script>
import ModalDialog from "@/components/commons/modal-dialog";
import BillingInvoiceServices from "@/services/billing/billing-invoice";
import InvoiceGeneralService from "@/services/invoice/invoice-general";
import {
    TEXT_INCLUDE_DECLINED_ITEMS_INVOICE,
    TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
} from "@/constants/billings.js";
import BillingEstimateServices from "@/services/billing/billing-estimate.js";
import { isEmpty, isNil } from "lodash";
const TYPE_TABS_DECLINED_ITEM = 5;
export default {
    components: {
        ModalDialog
    },
    computed: {
        clientId() {
            if (this.isEstimate) {
                return this.estimate.client?.id || this.client?.id;
            }
            return this.invoice.client?.id || this.client?.id;
        },
        title() {
            return `Print ${this.isEstimate ? "Estimate" : "Invoice"}`;
        },
        isEstimate() {
            return isEmpty(this.invoice);
        },
        includedDeclinedText() {
            return this.isEstimate
                ? TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
                : TEXT_INCLUDE_DECLINED_ITEMS_INVOICE;
        },
        textModule() {
            return this.isEstimate ? "estimate" : "invoice";
        }
    },
    props: {
        invoice: {
            type: Object,
            required: false
        },
        estimate: {
            type: Object,
            required: false
        },
        client: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            TEXT_INCLUDE_DECLINED_ITEMS_INVOICE,
            TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE,
            isLoading: false,
            includeDeclined: false
        };
    },
    methods: {
        async init() {
            this.$emit("show-loading", true);
            let res = null;
            this.includeDeclined = false;
            if (this.isEstimate) {
                res = await this.checkEstimateHasDeclinedItem();
            } else {
                res = await this.checkInvoiceHasDeclinedItem();
            }
            this.renderResponse(res);
        },
        async renderResponse(declinedItemCount) {
            if (Number(declinedItemCount) > 0) {
                this.open();
                this.$emit("show-loading", false);
            } else {
                await this.generatePrintPdf();
                this.$emit("show-loading", false);
            }
        },
        checkInvoiceHasDeclinedItem() {
            return InvoiceGeneralService.getTabCount({
                invoice_id: this.invoice.id,
                client_id: this.clientId,
                type: TYPE_TABS_DECLINED_ITEM
            }).then(response => {
                if (response?.declined_count) {
                    return response.declined_count;
                }
                return null;
            });
        },
        checkEstimateHasDeclinedItem() {
            return BillingEstimateServices.getDeclinedCount(
                this.estimate.id
            ).then(response => {
                if (!isNil(response)) {
                    return response;
                }
                return null;
            });
        },
        open() {
            this.$refs.modalDialog.open();
        },
        close() {
            this.isLoading = false;
            this.$refs.modalDialog.close();
        },
        printPDF() {
            let self = this;
            self.isLoading = true;
            self.generatePrintPdf().then(res => {
                self.isLoading = false;
                if (res) {
                    self.close();
                }
            });
        },
        async generatePrintPdf() {
            let self = this;
            let response;
            if (this.isEstimate) {
                response = await BillingEstimateServices.printPdf(
                    self.estimate.id,
                    self.includeDeclined
                );
            } else {
                response = await BillingInvoiceServices.generatePrintPdf(
                    self.invoice.id,
                    self.includeDeclined
                );
            }
            try {
                if (response.code === 200 && response.resource) {
                    this._message("Opening PDF");
                    self._redirect(response.resource, true);
                } else {
                    throw response.message;
                }
                return true;
            } catch (error) {
                self._message(
                    `Error : Unable print the ${this.textModule}`,
                    "danger"
                );
                console.error(error);
                return false;
            }
        }
    }
};
</script>
